import qs from 'qs';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

export const loginStructure = (username, password) => ({
    method: 'post',
    url: `${baseURL}/dws/setupapi/authorize`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({
        username,
        password,
        api_key: 'setup_manager'
    })
});

export const getSetupStateStructure = () => ({
    method: 'get',
    url: `${baseURL}/dws/setupapi/setup?api_key=setup_manager&language=es`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-access-token': localStorage.getItem('token')
    }
});
